import { useState } from "react";
import { ArticleExtraData } from "../../../../../articlePage/stateInterfaces";
import { ToggleSwitch } from "../../../../commonComponents/inline/toggleSwitch/toggleSwitch";
import { getTranslation } from "../../autoTickerRowWidget/autoTickerRowTranslations";
import { categoryObj } from "../../newYnetTvVerticalDynamic/components/newYnetTvVerticalDynamicComponenta";
import { NewsFlashSpecialMobileSlotList } from "../../newsflashAndTwentyFourSeven/components/newsFlashSpecial/mobile/newsFlashSpecialMobileSlotList";
import { mapArticleExtraDataToOverlayItems } from "../../newsflashAndTwentyFourSeven/components/newsFlashSpecial/utils/newsFlashUtils";

interface FlashPageSpecialMobileWebComponentProps {
    isLTR: boolean
    domain: string
    languageCode: string
    tickerArticles: ArticleExtraData[]
    isFirstInterval: boolean
    roofOngoingEvent: boolean
    shouldDisplayLoader: boolean
    shouldDisplayTicker: boolean
    highlightingDuration: number
    verticalBackgroundImage: string
    tabBackgroundColor: string
    category: categoryObj
    onOverlayOpen?: () => void
    onOverlayClose?: () => void
}

export const FlashPageSpecialMobileWebComponent = (props: FlashPageSpecialMobileWebComponentProps) => {

    const { isLTR, domain, languageCode, tickerArticles, isFirstInterval, roofOngoingEvent, shouldDisplayLoader, shouldDisplayTicker,
        highlightingDuration, verticalBackgroundImage, tabBackgroundColor, category, onOverlayOpen, onOverlayClose, } = props;
    const [typeOfView, setTypeOfView] = useState<"regular" | "expanded">("regular");
    const [openedItemIndex] = useState<string | null>(getSharedItem() || null);
    const [openedItems, setOpenedItems] = useState<string[]>([]);

    const lang = languageCode ? languageCode.slice(0, 2) : "he";
    const overlayItems = mapArticleExtraDataToOverlayItems(tickerArticles, verticalBackgroundImage);
    const articleMinutesDiff = (article: ArticleExtraData) => {
        return Math.floor((new Date().getTime() - new Date(article.dateUpdatedOnSite).getTime()) / (1000 * 60));
    };

    const onSwitchChange = () => {
        if (typeOfView === "regular") {
            const allIds = tickerArticles.map(item => item.articleId);
            const missing = allIds.filter(id => !openedItems.includes(id));
            setTypeOfView("expanded");
            setOpenedItems([...openedItems, ...missing]);
        } else if (typeOfView === "expanded") {
            setTypeOfView("regular");
            setOpenedItems([]);
        }
    }

    const updateOpenedItems = (id: string) => {
        const isOpen = openedItems.includes(id);
        setOpenedItems(
            isOpen
                ? openedItems.filter(item => item !== id)
                : [...openedItems, id]
        );
    }

    return (
        <>
            <div className="flash-page-special-tab" style={{ backgroundColor: tabBackgroundColor }}>
                <div className="tab-title">
                    {/* <div className="tab-icon"></div> */}

                    <div className="tab-text">{getTranslation(lang, "News Flash")}</div>
                </div>

                <div className="display-mode-toggle">
                    <div className="toggle-title">{getTranslation(lang, "ExtendedView")}</div>

                    <ToggleSwitch checked={typeOfView === "expanded"} onSwitchPressed={onSwitchChange} />
                </div>
            </div>

            <NewsFlashSpecialMobileSlotList
                isLTR={isLTR}
                domain={domain}
                category={category}
                openedItems={openedItems}
                languageCode={languageCode}
                overlayItems={overlayItems}
                onOverlayOpen={onOverlayOpen}
                onOverlayClose={onOverlayClose}
                tickerArticles={tickerArticles}
                onToggleItem={updateOpenedItems}
                openedItemIndex={openedItemIndex}
                isFirstInterval={isFirstInterval}
                roofOngoingEvent={roofOngoingEvent}
                shouldDisplayLoader={shouldDisplayLoader}
                shouldDisplayTicker={shouldDisplayTicker}
                highlightingDuration={highlightingDuration}
                accordionOpenState={typeOfView === "expanded"}
            />
        </>
    )
}

FlashPageSpecialMobileWebComponent.siteScriptName = "FlashPageSpecialMobileWebComponent"

const getSharedItem = (): string => {
    const url = typeof window !== "undefined" ? window.location.href : "";
    const urlSliceIndex = url.indexOf("#")
    if (urlSliceIndex !== -1) {
        return url.slice(urlSliceIndex + 1)
    }
    return ""
}
